<footer>
  <div class="footer-container" [ngClass]="{ 'is-phone-portrait': breakpointService.isMobile }">
    <div class="footer-row">
      <nav class="footer-resources-bar" [ngClass]="{ 'is-phone-portrait': breakpointService.isMobile }">
        <a
          href="https://pcl.content.us.clicklearn.com/publiccontent/CraftLink.1033/CraftLink.htm"
          target="_blank"
          rel="noopener noreferrer"
          ><mat-icon fontSet="material-symbols-outlined">help_center</mat-icon><span>Craft Learning Center</span></a
        >
        <a href="mailto:support&#64;pcl.com"><mat-icon>email</mat-icon><span>support&#64;pcl.com</span></a>
        <a href="tel:18555335252"><mat-icon>phone</mat-icon><span>1-855-533-5252</span></a>
        <a [routerLink]="['/', 'privacy-policy']" target="_top"><span>Privacy Policy</span></a>
        <a [routerLink]="['/', 'terms-of-use']" target="_top"><span>Terms of Use</span></a>
        <a [routerLink]="['/', 'accessibility']" target="_top"><span>Accessibility</span></a>
      </nav>
      <div class="footer-social-nav">
        <ul>
          <li>
            <div>
              <a
                class="footer-social-media-link"
                href="https://www.instagram.com/pcl_construction/"
                target="_blank"
                rel="noopener noreferrer">
                <fa-icon [icon]="faInstagram"></fa-icon>
              </a>
            </div>
          </li>
          <li>
            <div>
              <a
                class="footer-social-media-link"
                href="https://twitter.com/PCLConstruction"
                target="_blank"
                rel="noopener noreferrer">
                <fa-icon [icon]="faXTwitter"></fa-icon>
              </a>
            </div>
          </li>
          <li>
            <div>
              <a
                class="footer-social-media-link"
                href="https://www.youtube.com/user/pclconstructionvids?feature=results_main"
                target="_blank"
                rel="noopener noreferrer">
                <fa-icon [icon]="faYoutube"></fa-icon>
              </a>
            </div>
          </li>
          <li>
            <div>
              <a
                class="footer-social-media-link"
                href="https://www.linkedin.com/company/pcl-construction/"
                target="_blank"
                rel="noopener noreferrer">
                <fa-icon [icon]="faLinkedin"></fa-icon>
              </a>
            </div>
          </li>
          <li>
            <div>
              <a
                class="footer-social-media-link"
                href="http://www.facebook.com/PCLconstruction"
                target="_blank"
                rel="noopener noreferrer">
                <fa-icon [icon]="faFacebook"></fa-icon>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer-row align-end">
      <div class="footer-logo" [ngClass]="{ hidden: breakpointService.isMobile }">
        <a href="https://www.pcl.com/" target="_parent">
          <img src="assets/images/pcl_construction_logo.svg" width="68" alt="PCL Construction logo" />
        </a>
      </div>
      <div class="footer-copyright">
        <p>Copyright © {{ currentYear }} PCL Constructors Inc.</p>
        <p>All rights reserved.</p>
      </div>
    </div>
  </div>
</footer>
